import * as React from "react";
import { styled } from "@mui/material";

//region [[ Styles ]]

const PrivatePlaceholderView = styled("div")({
  color: "transparent",
  textShadow: "0 0 10px rgba(0,0,0,0.5)",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PrivatePlaceholderProps {
  children?: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PrivatePlaceholder = ({ ...props }: PrivatePlaceholderProps) => {
  return (
    <PrivatePlaceholderView title={"Private information"}>
      {props.children || "Private"}
    </PrivatePlaceholderView>
  );
};
